import './_description.scss';
import React from 'react';
import { Badge, FormGroup, ControlLabel } from 'react-bootstrap';
import classNames from 'classnames';
import PropTypes from 'prop-types';

const Field = ({ direction, register, languageName, languageCode, value }) => (
  <FormGroup className={classNames(`services-description services-description__${direction}`)}>
    <ControlLabel>
      Description
      {' '}
      <Badge>{languageName}</Badge>
    </ControlLabel>
    <textarea
      className="form-control services-description__textarea"
      name={languageCode}
      rows={8}
      defaultValue={value}
      {...register(languageCode)}
    />
  </FormGroup>
);

Field.propTypes = {
  direction: PropTypes.any,
  register: PropTypes.any,
  languageName: PropTypes.any,
  languageCode: PropTypes.any,
  value: PropTypes.any,
};

export default Field;
